export default __webpack_public_path__ + "static/media/dot.0f81884c.svg";